import { render } from "./CounselingReportEdit.vue?vue&type=template&id=1050bafe&ts=true"
import script from "./CounselingReportEdit.vue?vue&type=script&lang=ts"
export * from "./CounselingReportEdit.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__